import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { theme } from '@dls/web';
import { useState } from 'react';
import styled from 'styled-components';
import EntitySelectionModal from './EntitySelectionModal/index.js';
import '../../../../../../authentication/context/AuthenticationProvider.js';
import { formatFullName } from '../../../../../../authentication/helpers/format.js';
import '@geit/ui-components';
import { useCurrentUser } from '../../../../../../authentication/hooks/useCurrentUser.js';
import 'qs';
import 'uuid';
import '../../../../../../authentication/navigate.js';
const UserEntity = _ref => {
  let {
    onApplyChange,
    isAMUser,
    isMobile
  } = _ref;
  const [showModal, setModalVisible] = useState(false);
  const {
    user
  } = useCurrentUser();
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(SCEntityLink, {
      onClick: () => isAMUser ? void 0 : setModalVisible(true),
      id: "user-entity",
      color: isAMUser || isMobile ? theme.main.colours.white : theme.main.colours.black,
      children: "".concat(formatFullName(user.firstName, user.lastName), " (").concat(!user.entitySelection ? "-" : "BRN " + user.entitySelection.refNumber, ")")
    }), /* @__PURE__ */jsx(EntitySelectionModal, {
      visible: showModal,
      setVisible: setModalVisible,
      onApplyChange
    })]
  });
};
const SCEntityLink = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  font-size: 16px;\n  letter-spacing: 1px;\n  line-height: 1.75;\n  cursor: pointer;\n"])), props => props.color ? props.color : theme.main.colours.black);
export { UserEntity as default };